import React from 'react';
import SessionCountDown from "./General/sessionCountDown";
import _ from 'lodash';
import { LEGAL_ADVICE_TEXT, TOBA_PATH, TOBA_SHORT_TEXT } from '../helpers/variables';
import CONTENT_STRINGS from '../helpers/contentStrings';
import { Breadcrumbs } from 'arag-ui-lib';

const BreadCrumb = (props) => {
    const {
        PathName,
        Push,
        Wrapper,
        breadcrumbTestId,
    } = props;


    let routeId = _.last(PathName.split("/"));
    /*
     * when adding a new route, first the new route must be added in the userContentRouter
     * and then in this component. To add it here, you have to add another object to the
     * acceptedRoutes table like below. key value must be equal to the last subpath of
     * the new path. the value is equal to the label you want to be displayed in the breadcrumb
     * the route must be equal to the full route starting from home (/)
     * */
    let acceptedRoutes = [
        {key: '', value: CONTENT_STRINGS.HOME, route: '/'},
        {key: 'add-solicitor', value: `Create ${LEGAL_ADVICE_TEXT}`, route: '/solicitors/add-solicitor'},
        {key: 'solicitors', value: `${LEGAL_ADVICE_TEXT}s`, route: '/solicitors'},
        {key: 'manage-account', value: CONTENT_STRINGS.MANAGE_ACCOUNT, route: '/manage-account'},
        {key: 'solicitor-groups', value: `${LEGAL_ADVICE_TEXT} Groups`, route: '/solicitors/solicitor-groups'},
        {key: 'edit-solicitor-group', value: `Edit ${LEGAL_ADVICE_TEXT} Group`, route: '/solicitors/solicitor-groups/edit-solicitor-group/' + routeId},
        {key: 'app-form-referral-settings', value: CONTENT_STRINGS.APPLICATION_FORM_REFERRAL_SETTINGS, route: '/app-form-referral-settings'},
        {key: 'new-application', value: CONTENT_STRINGS.NEW_APPLICATION, route: '/new-application'},
        {key: 'application-and-policies', value: CONTENT_STRINGS.APPLICATIONS_AND_POLICIES, route: '/application-and-policies'},
        {key: 'newUser', value: CONTENT_STRINGS.NEW_USER, route: '/newUser'},
        {key: 'application-policy', value: CONTENT_STRINGS.APPLICATION_POLICY, route: '/application-and-policies/application-policy/' + routeId},
        {key: `${TOBA_PATH}`, value: `${TOBA_SHORT_TEXT}`, route: `/manage-account/${TOBA_PATH}`},
        {key: 'add-toba', value: CONTENT_STRINGS.TOBA, route: '/solicitors/add-toba'},
        {key: `${TOBA_PATH}s`, value: `${TOBA_SHORT_TEXT}s`, route: `/solicitors/${TOBA_PATH}s`},
        {key: 'users', value: CONTENT_STRINGS.USERS, route: '/users'},
        {key: 'edit-user', value: CONTENT_STRINGS.EDIT_USER, route: '/users/edit-user/' + routeId},
        {key: 'edit-solicitor', value: `Edit ${LEGAL_ADVICE_TEXT}`, route: '/solicitors/edit-solicitor/' + routeId},
        {key: 'notifications', value: CONTENT_STRINGS.NOTIFICATIONS, route: '/notifications'},
        {key: 'premium-settings', value: CONTENT_STRINGS.PREMIUM_SETTINGS, route: '/premium-settings'},
        {key: 'new-premium-settings', value: CONTENT_STRINGS.NEW_PREMIUM_SETTINGS, route: '/premium-settings/new-premium-settings'},
        {key: 'edit-premium-settings', value: CONTENT_STRINGS.EDIT_PREMIUM_SETTINGS, route: '/premium-settings/edit-premium-settings/' + routeId},
        {key: 'add-article', value: CONTENT_STRINGS.CREATE_NEW_ARTICLE, route: '/articles/add-article'},
        {key: 'articles', value: CONTENT_STRINGS.ARTICLES, route: '/articles'},
        {key: 'edit-article', value: CONTENT_STRINGS.EDIT_ARTICLES, route: '/articles/edit-article/' + routeId},
        {key: 'advance-disbursements', value: CONTENT_STRINGS.ADVANCE_DISBURSEMENTS, route: '/advance-disbursements'},
        {key: 'add', value: CONTENT_STRINGS.CREATE_ADVANCE_DISBURSEMENT, route: '/advanced-disbursements/add'},
        {key: 'internal-alerts', value: CONTENT_STRINGS.INTERNAL_ALERTS, route: '/internal-alerts'},
        {key: 'new-internal-alert', value: CONTENT_STRINGS.NEW_INTERNAL_ALERT, route: '/new-internal-alert'},
        {key: 'edit-internal-alert', value: CONTENT_STRINGS.EDIT_INTERNAL_ALERT, route: '/internal-alerts' + routeId},
    ];
    return (
        <div className={Wrapper} style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
            <Breadcrumbs
                acceptedRoutes={acceptedRoutes}
                pathname={PathName}
                onClick={(route) => Push(route)}
                breadcrumbsTestId={breadcrumbTestId}
            />
            <SessionCountDown/>
        </div>
    )
};

export default BreadCrumb;